import React from 'react';
import { useTranslation } from "react-i18next";
import { SelectOption } from "./SelectOption";

export const CountryPicker = ({
    countryKey,
    countryId = 'CountryPicker',
    countryName = "country",
    countryLabel = "",
    handleChange,
    formData,
    countryList = [],
  }) => {

  const { t } = useTranslation();

  // set a default value for 'countryLabel' since 't' not available until now
  const countryLabelToShow =
    countryLabel.length > 0  ? countryLabel : t('sku.category.optionValue')
    // Choose one:

  // 'key' requires the various 'countryCode' values to be unique...
  const countryOptions = countryList.map(
    countryCode =>
      <SelectOption
        key      = {countryCode}
        optValue = {countryCode}
        optLabel = {t('circle.country.optionValue' + countryCode)}
      />
  );

  return (
    <select
      key          = {countryKey}
      type         = "text"
      id           = {countryId}
      name         = {countryName}
      onChange     = {handleChange}
      value        = {formData == undefined  ? undefined : formData.country}
    >
      {/* header line in options list: */}
      <option value="">{countryLabelToShow}</option>
      {/* Choose one: */}

      {/* list of countries to show as options: */}
      {countryOptions}
    </select>
  )}

export default CountryPicker
